import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Plus, X, FileText, Upload, MessageCircle } from "lucide-react";

const ACTIONS = [
  { label: "New Filing", icon: FileText, to: "/filing" },
  { label: "Upload Document", icon: Upload, to: "/documents" },
  { label: "Ask Advisor", icon: MessageCircle, to: "/ai" },
];

export default function MobileFAB() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (user?.role !== "taxpayer") return null;

  const handleAction = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <div className="lg:hidden fixed bottom-20 right-4 z-50 flex flex-col-reverse items-end gap-3">
      {/* Action chips — slide up when open */}
      {ACTIONS.map((action, i) => {
        const Ic = action.icon;
        return (
          <button
            key={action.to}
            onClick={() => handleAction(action.to)}
            aria-label={action.label}
            className={`flex items-center gap-2 bg-card border border-border shadow-md rounded-full px-4 py-2.5 text-sm font-medium text-foreground
              transition-all duration-200
              ${open
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4 pointer-events-none"
              }`}
            style={{ transitionDelay: open ? `${i * 50}ms` : "0ms" }}
          >
            <Ic className="h-4 w-4 text-primary shrink-0" aria-hidden="true" />
            {action.label}
          </button>
        );
      })}

      {/* Main FAB button */}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Close actions" : "Quick actions"}
        aria-expanded={open}
        data-testid="mobile-fab"
        className="h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-lg flex items-center justify-center transition-transform duration-200 active:scale-95"
      >
        {open
          ? <X className="h-6 w-6" aria-hidden="true" />
          : <Plus className="h-6 w-6" aria-hidden="true" />
        }
      </button>
    </div>
  );
}
